
import React from 'react';
import { SidebarHeader as SidebarHeaderComponent } from '@/components/ui/sidebar';
import { Shield } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';
import PropertyShieldLogo from '@/components/ui/PropertyShieldLogo';

const SidebarHeader: React.FC = () => {
  const { state, isMobile } = useSidebar();
  // On mobile, always show full content (not collapsed)
  const isCollapsed = state === 'collapsed' && !isMobile;

  return (
    <SidebarHeaderComponent className="border-b p-4">
      {!isCollapsed ? (
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center flex-shrink-0">
            <Shield className="h-5 w-5 text-primary-foreground" />
          </div>
          <div className="min-w-0 flex-1">
            <PropertyShieldLogo size="sm" />
          </div>
        </div>
      ) : (
        <div className="flex justify-center">
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
            <Shield className="h-5 w-5 text-primary-foreground" />
          </div>
        </div>
      )}
    </SidebarHeaderComponent>
  );
};

export default SidebarHeader;
